// extracted by mini-css-extract-plugin
export default {"decorator":"_3C40OroiZcZ9dvpUFNbThl","icon":"_2U3NiCK2CibHyLn1qgEK3E"};